import React, { ReactNode } from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';
import { PlacementType, placementTypes } from './styles';

interface TableTooltipProps {
  classes?: string;
  text: ReactNode;
  placement?: PlacementType;
  children: ReactNode;
  tiny?: boolean;
}

// Convert our placement types to MUI's placement types
const getMuiPlacement = (placement?: PlacementType): 'top' | 'bottom' | 'left' | 'right' => {
  switch (placement) {
    case placementTypes.TOP:
      return 'top';
    case placementTypes.LEFT:
      return 'left';
    case placementTypes.RIGHT:
      return 'right';
    case placementTypes.BOTTOM:
    default:
      return 'bottom';
  }
};

const TableTooltip: React.FC<TableTooltipProps> = ({
  classes,
  text,
  placement,
  children,
}) => {
  const muiPlacement = getMuiPlacement(placement);

  return (
    <MuiTooltip
      title={text}
      placement={muiPlacement}
      arrow={false}
      className={`table-tooltip-wrapper ${classes}`}
      PopperProps={{
        modifiers: [
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              altAxis: true,
              padding: 8,
            },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'novotalk.$backgroundColor',
            color: 'novotalk.$textColorDarkBlue',
            fontSize: 'body2.fontSize',
            border: '1px solid',
            borderColor: 'novotalk.$borderColorTooltip',
            boxShadow: '0 4px 8px 0',
            boxShadowColor: 'novotalk.$shadowTooltipColor',
            borderRadius: 1,
            padding: '8px 12px',
            maxWidth: '200px !important',
            minWidth: '80px !important',
            width: 'auto !important',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            lineHeight: '1.4em',
            '& .MuiTooltip-arrow': {
              display: 'none'
            },
          },
        },
      }}
    >
      <span>{children}</span>
    </MuiTooltip>
  );
};

export { placementTypes };
export type { PlacementType };
export default TableTooltip; 